import { render, staticRenderFns } from "./AppLanding.vue?vue&type=template&id=13b5cbde&scoped=true&"
import script from "./AppLanding.vue?vue&type=script&lang=js&"
export * from "./AppLanding.vue?vue&type=script&lang=js&"
import style0 from "./AppLanding.vue?vue&type=style&index=0&id=13b5cbde&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b5cbde",
  null
  
)

export default component.exports